var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("aside", { staticClass: "c-account-nav u-margin-bottom-small" }, [
    _c("h1", { staticClass: "t-heading-4" }, [
      _vm._v("\n    Hello " + _vm._s(_vm.customerName) + "\n  ")
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "c-account-nav__email t-heading-6" }, [
      _vm._v("\n    " + _vm._s(_vm.customerEmail) + "\n  ")
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "c-account-nav__logout u-margin-bottom-x-small" }, [
      _vm._v("\n    (not " + _vm._s(_vm.customerName) + "?\n    "),
      _c(
        "a",
        {
          staticClass: "c-account-nav__link t-link",
          attrs: { href: "/account/logout" }
        },
        [_vm._v("\n      Sign out\n    ")]
      ),
      _vm._v("\n    )\n  ")
    ]),
    _vm._v(" "),
    _c(
      "p",
      { staticClass: "c-account-nav__description u-margin-bottom-x-small" },
      [
        _vm._v(
          "\n    From your account dashboard you can view your recent orders and manage your shipping and billing addresses\n  "
        )
      ]
    ),
    _vm._v(" "),
    !_vm.hideNav && _vm.windowWidth < 1200
      ? _c("div", { staticClass: "input u-margin-bottom-small" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selected,
                  expression: "selected"
                }
              ],
              staticClass: "c-account-nav__select",
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.selected = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            _vm._l(_vm.options, function(option) {
              return _c(
                "option",
                { key: option.value, domProps: { value: option.value } },
                [_vm._v("\n        " + _vm._s(option.label) + "\n      ")]
              )
            }),
            0
          )
        ])
      : !_vm.hideNav
      ? _c(
          "ul",
          { staticClass: "c-account-nav__list u-list-simple" },
          _vm._l(_vm.options, function(option) {
            return _c(
              "li",
              {
                key: option.value,
                staticClass: "c-account-nav__list-item t-heading-6",
                class: { "item-active": _vm.isActive(option.value) }
              },
              [
                _c(
                  "a",
                  { staticClass: "t-link", attrs: { href: option.value } },
                  [_vm._v("\n        " + _vm._s(option.label) + "\n      ")]
                )
              ]
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }